import * as React from "react";
import { Link } from "react-router";

import { saveRecentSearches } from "../../RecentSearches";

function TitlePanel(props: { [x: string]: any }) {
    let classNameTitle = "regular";
    if (props.articleDeprecated) {
        classNameTitle = "deprecated";
    }

    return (
        <div className="mfcss_card-article-2--title">
            <Link
                className="title"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore -- FIXME check if this does anything
                description={props.description}
                to={props.detailLink}
                onClick={() => {
                    saveRecentSearches();
                    return props.onClick();
                }}>
                <h4 className={classNameTitle}>{props.name}</h4>
            </Link>
        </div>
    );
}

export default TitlePanel;
